<div class="modal" [class.hidden]="!isOpen" (click)="closeOnBackdropClick($event)">
  <div class="modal-content">

    <!-- Header with close button and title -->
    <div class="modal-header">
      <button class="close-btn" (click)="close()">
        <span class="material-icons">close</span>
      </button>
      <span class="header-title">{{getString('priceAlertEdit')}}</span>
      <button class="remove-btn" (click)="removeFromWishlist()">{{getString('priceAlertRemove')}}</button>
    </div>

    <!-- Main content in landscape layout -->
    <div class="modal-body">

      <!-- Left side: Poster -->
      <div class="poster-container">
        <img [src]="getItemImageUrl()" [alt]="item?.title" class="poster-image">
      </div>

      <!-- Right side: Price settings -->
      <div class="settings-container">

        <h2 class="item-title">{{getItemTitle()}}</h2>

        <div class="notification-intro">
          <span class="material-icons bell-icon">notifications</span>
          <span class="intro-text">{{getString('priceAlertNotifyWhen')}}</span>
        </div>

        <!-- 4K Price Section (Vudu only) - shown first -->
        <div class="price-section" *ngIf="has4kPrice()">
          <h3 class="price-section-title">{{getString('priceAlert4kPrice')}}</h3>

          <div class="radio-option" (click)="on4kOptionChange('under')">
            <div class="radio-circle" [class.selected]="fourKPriceOption === 'under'">
              <div class="radio-inner" *ngIf="fourKPriceOption === 'under'"></div>
            </div>
            <span class="radio-label">{{getString('priceAlertUnder')}} <strong>{{getUnder4kPriceDisplay()}}</strong></span>
          </div>

          <div class="radio-option" (click)="on4kOptionChange('custom')">
            <div class="radio-circle" [class.selected]="fourKPriceOption === 'custom'">
              <div class="radio-inner" *ngIf="fourKPriceOption === 'custom'"></div>
            </div>
            <span class="radio-label">&lt;=</span>
            <input type="number"
                   class="custom-price-input"
                   [placeholder]="getString('priceAlertCustomPrice')"
                   [value]="fourKCustomPrice"
                   (input)="on4kCustomPriceChange($event)"
                   (click)="$event.stopPropagation(); on4kOptionChange('custom')"
                   step="0.01"
                   min="0">
            <span class="currency-symbol">{{getCurrencySymbol()}}</span>
          </div>
        </div>

        <!-- HD Price Section (or HD/4K for iTunes 4K movies) -->
        <div class="price-section" *ngIf="hasHdPrice()">
          <h3 class="price-section-title">{{getHdPriceSectionTitle()}}</h3>

          <div class="radio-option" (click)="onHdOptionChange('under')">
            <div class="radio-circle" [class.selected]="hdPriceOption === 'under'">
              <div class="radio-inner" *ngIf="hdPriceOption === 'under'"></div>
            </div>
            <span class="radio-label">{{getString('priceAlertUnder')}} <strong>{{getUnderHdPriceDisplay()}}</strong></span>
          </div>

          <div class="radio-option" (click)="onHdOptionChange('custom')">
            <div class="radio-circle" [class.selected]="hdPriceOption === 'custom'">
              <div class="radio-inner" *ngIf="hdPriceOption === 'custom'"></div>
            </div>
            <span class="radio-label">&lt;=</span>
            <input type="number"
                   class="custom-price-input"
                   [placeholder]="getString('priceAlertCustomPrice')"
                   [value]="hdCustomPrice"
                   (input)="onHdCustomPriceChange($event)"
                   (click)="$event.stopPropagation(); onHdOptionChange('custom')"
                   step="0.01"
                   min="0">
            <span class="currency-symbol">{{getCurrencySymbol()}}</span>
          </div>
        </div>

        <!-- SD Price Section -->
        <div class="price-section" *ngIf="hasSdPrice()">
          <h3 class="price-section-title">{{getString('priceAlertSdPrice')}}</h3>

          <div class="radio-option" (click)="onSdOptionChange('under')">
            <div class="radio-circle" [class.selected]="sdPriceOption === 'under'">
              <div class="radio-inner" *ngIf="sdPriceOption === 'under'"></div>
            </div>
            <span class="radio-label">{{getString('priceAlertUnder')}} <strong>{{getUnderSdPriceDisplay()}}</strong></span>
          </div>

          <div class="radio-option" (click)="onSdOptionChange('custom')">
            <div class="radio-circle" [class.selected]="sdPriceOption === 'custom'">
              <div class="radio-inner" *ngIf="sdPriceOption === 'custom'"></div>
            </div>
            <span class="radio-label">&lt;=</span>
            <input type="number"
                   class="custom-price-input"
                   [placeholder]="getString('priceAlertCustomPrice')"
                   [value]="sdCustomPrice"
                   (input)="onSdCustomPriceChange($event)"
                   (click)="$event.stopPropagation(); onSdOptionChange('custom')"
                   step="0.01"
                   min="0">
            <span class="currency-symbol">{{getCurrencySymbol()}}</span>
          </div>

          <div class="radio-option" (click)="onSdOptionChange('ignore')">
            <div class="radio-circle" [class.selected]="sdPriceOption === 'ignore'">
              <div class="radio-inner" *ngIf="sdPriceOption === 'ignore'"></div>
            </div>
            <span class="radio-label">{{getString('priceAlertIgnoreSd')}}</span>
          </div>
        </div>

        <!-- Single Price Section (for items without SD/HD like music, apps, books) -->
        <div class="price-section" *ngIf="hasSinglePrice()">
          <h3 class="price-section-title">{{getString('priceAlertPrice')}}</h3>

          <div class="radio-option" (click)="onSinglePriceOptionChange('under')">
            <div class="radio-circle" [class.selected]="singlePriceOption === 'under'">
              <div class="radio-inner" *ngIf="singlePriceOption === 'under'"></div>
            </div>
            <span class="radio-label">{{getString('priceAlertUnder')}} <strong>{{getUnderSinglePriceDisplay()}}</strong></span>
          </div>

          <div class="radio-option" (click)="onSinglePriceOptionChange('custom')">
            <div class="radio-circle" [class.selected]="singlePriceOption === 'custom'">
              <div class="radio-inner" *ngIf="singlePriceOption === 'custom'"></div>
            </div>
            <span class="radio-label">&lt;=</span>
            <input type="number"
                   class="custom-price-input"
                   [placeholder]="getString('priceAlertCustomPrice')"
                   [value]="singleCustomPrice"
                   (input)="onSingleCustomPriceChange($event)"
                   (click)="$event.stopPropagation(); onSinglePriceOptionChange('custom')"
                   step="0.01"
                   min="0">
            <span class="currency-symbol">{{getCurrencySymbol()}}</span>
          </div>
        </div>

        <!-- Buy/Rent Radio Buttons (mutually exclusive) - Only for movies, not TV seasons -->
        <div class="buy-rent-section" *ngIf="isMovieItem()">
          <label class="radio-option" (click)="onPurchaseTypeChange('buy')">
            <div class="radio-circle" [class.selected]="purchaseType === 'buy'">
              <div class="radio-inner" *ngIf="purchaseType === 'buy'"></div>
            </div>
            <span class="radio-label">{{getString('priceAlertBuy')}}</span>
          </label>

          <label class="radio-option" (click)="onPurchaseTypeChange('rent')">
            <div class="radio-circle" [class.selected]="purchaseType === 'rent'">
              <div class="radio-inner" *ngIf="purchaseType === 'rent'"></div>
            </div>
            <span class="radio-label">{{getString('priceAlertRent')}}</span>
          </label>
        </div>

        <!-- Save Button -->
        <button class="save-btn" (click)="saveSettings()">{{getString('priceAlertSave')}}</button>

      </div>
    </div>

  </div>
</div>
